import axios from "../../axios";
import * as Requests from "../../requests";

export const activateWorkingHoursScheduleApi = (token: string, scheduleId: string, storeId: string) => {
    return axios.put(
        Requests.WORKING_HOURS_SCHEDULE_API(scheduleId),
        { store_id: storeId, is_active: true },
        {
            headers: { token },
            baseURL: process.env.PICKUP_ENDPOINTS,
        }
    );
};
